<template>
  <div v-if="article.heroImage && article.heroImage.url" class="spotlight-hero">
    <img
      :src="article.heroImage.url"
      :alt="article.artistName"
      class="spotlight-hero-img"
    />
  </div>
</template>

<script>
export default {
  name: 'SpotlightHeader',
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.spotlight-hero {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}

.spotlight-hero-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}
</style>
